require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-z-8-pd-9-l.json") })
        }
      }, "path---photos-professional-z-8-pd-9-l");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-z-8-pd-9-l!./.cache/json/photos-professional-z-8-pd-9-l.json
// module id = 1138
// module chunks = 231608221292675